import { flatMap, get, has } from "lodash";
import { useReducer } from "react";
import { toast } from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Questionaries {
  questionariesSubTagData: object;
  curQuestionariesSubTagEditData: any;
  subTagList: object;
  allSubTagList: object;
  isLoadSubTag: boolean;
  totalPageCount: number;
  totalData: number;
  error: string;
}

const initialArgs: Questionaries = {
  questionariesSubTagData: [],
  curQuestionariesSubTagEditData: {},
  subTagList: {},
  allSubTagList: {},
  isLoadSubTag: false,
  totalPageCount: 0,
  totalData: 17,
  error: "",
};

const reducer = (state: Questionaries, action: Questionaries) => {
  return { ...state, ...action };
};

const useQuestionariesSubTag = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getQuestionariesSubTag = async () =>
    // page: string,
    // listPerPage: string,
    // searchText: string,
    {
      try {
        const result: any = await api.get(`/api/v1/questionnaires/subTags`);

        if (result.data.status) {
          setState({
            ...state,
            questionariesSubTagData: result.data.data.data,
            totalPageCount: get(result, "data.data.totalPageCount", 0),
            totalData: get(result, "data.data.totalData", 0),
          });

          return true;
        } else {
          const errorStr = has(result.data, "errors")
            ? Object(flatMap(result.data))[1].msg
            : result.data.message;
          setState({ ...state, error: errorStr });
          return false;
        }
      } catch (error: any) {
        setState({ ...state, error: error.message });
        return false;
      }
    };
  const createQuestionariesSubTag = async (param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const result: any = await api.post(
        "/api/v1/questionnaires/questionnairesSubTags",
        paramObj,
      );

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success("Questionaries Sub Tag has been Added Successfully");
        setState({ ...state, questionariesSubTagData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  //Edit
  const editQuestionariesSubTag = async (questionariesSubTagId: string) => {
    try {
      const result: any = await api.get(
        `/api/v1/questionnaires/questionnairesSubTags/${questionariesSubTagId}`,
      );

      if (result.data.status) {
        const newQuestionnaires = {
          ...result.data.data,
        };

        setState({
          ...state,
          curQuestionariesSubTagEditData: newQuestionnaires,
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        // toast.error("");
        setState({
          ...state,
          error: errorStr,
          // curQuestionariesSubTagEditData: {},
        });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({
        ...state,
        error: error.message,
        // curQuestionariesSubTagEditData: {},
      });
      return false;
    }
  };
  //SubTagList Dropdown Field
  const getSubTagList = async () => {
    try {
      const result: any = await api.get("/api/v1/questionnaires/allSubTags");

      if (result.data.status) {
        setState({
          ...state,
          allSubTagList: result.data.data,
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const updateState = (payload: any) => {
    setState({ ...state, ...payload });
  };
  //For Update
  const updateQuestionariesSubTag = async (param: any) => {
    const paramObj = {
      ...param,
      subTags:
        param.subTags &&
        param.subTags.map((tag: any) => ({
          tagName: tag.tagName,
          subTagName: tag.subTagName,
          subTagId: tag.subTagId,
        })),
    };

    try {
      const result: any = await api.post(
        `/api/v1/questionnaires/questionnairesSubTags`,
        paramObj,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        //toast.dismiss(updateInsituteToast);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  return {
    ...state,
    getQuestionariesSubTag,
    createQuestionariesSubTag,
    editQuestionariesSubTag,
    getSubTagList,
    updateState,
    updateQuestionariesSubTag,
  };
};

export default useQuestionariesSubTag;
